import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { SelectComponent } from "../../components/Controls/Select/Select";
import * as actions from "../../store/appointments/actions";
import { injectIntl } from "react-intl";
import './style.scss';
import { useSelector } from "react-redux";
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { calendar } from '../../utils/images';
import moment from "moment";
import { Tooltip } from "@material-ui/core";
import RefreshIcon from '@material-ui/icons/Refresh';

const Filterform = ({ intl: { messages }, setSearchValues, query }) => {
  const dispatch = useDispatch();
  const { usersList } = useSelector((state) => state.appointments);
  const [startDateState, setStartDateState] = useState(moment().subtract(7, "days").format('YYYY-MM-DD'));
  const [endDateState, setEndDateState] = useState(moment().format('YYYY-MM-DD'));
  const [specialistList, setSpecialistList] = useState([]);
  const appStatus = [
    {id: 0, name: messages.appointments.statistics.allAppointments},
    {id: 1, name: messages.appointments.statistics.newAppointment},
    {id: -1, name: messages.appointments.statistics.notCompletedAppointment},
    {id: 4, name: messages.appointments.statistics.completedAppointment},
    {id: 5, name: messages.appointments.statistics.cancelledAppointment},
    {id: 6, name: messages.appointments.statistics.missedAppointment},
  ]
  useEffect(() => {
    dispatch(actions.getAppointmentsUsersListRequest({ roleId: -2 }));
  }, [dispatch]);

  // Users List
  useEffect(() => {
      if (usersList && usersList.length > 0) {
          let list = [];
          list.push({id: 0, name: messages.appointments.allSpecialist_placeholder});
          usersList.forEach((item) => {
              list.push({
                  id: item.id,
                  name: item.name,
              });
          });
          setSpecialistList(list);
      } else {
          setSpecialistList([]);
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usersList])

  const payload = { page: 1, sort: "id,desc" };
  const initialValues = {
    appointmentStatus: parseInt(query?.appointmentStatus) ||0,
    userId: parseInt(query?.userId) || 0,
    startDate: query?.startDate || null,
    endDate: query?.endDate || null,
  };   
  const Filterchema = Yup.object().shape({
    appointmentStatus: Yup.object().nullable(),
    userId: Yup.object().nullable(),
    startDate: Yup.object().nullable(),
    endDate: Yup.object().nullable(),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: Filterchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {},
  });

  useEffect(() => {
    formik.setFieldValue("startDate", query?.startDate || null);
    formik.setFieldValue("endDate", query?.endDate || null);
    formik.setFieldValue("appointmentStatus", parseInt(query?.appointmentStatus) || 0);
    formik.setFieldValue("userId", parseInt(query?.userId) || 0);
    setStartDateState(query?.startDate || null);
    setEndDateState(query?.endDate || null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);
  
  const searchWithSelect = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ appointmentStatus: e.target.value, userId: formik.values.userId });
    dispatch(
      actions?.getAppointmentsRequest({
        ...payload,
        ...formik.values,
        appointmentStatus: e.target.value,
      })
    );
  };

  const searchWithUser = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    setSearchValues({ appointmentStatus: formik.values.appointmentStatus, userId: e.target.value });
    dispatch(
      actions?.getAppointmentsRequest({
        ...payload,
        ...formik.values,
        appointmentStatus: e.target.value,
      })
    );
  };

  const searchWithDate = () => {
      formik.setFieldValue('startDate', startDateState);
      formik.setFieldValue('endDate', endDateState);
      setSearchValues({ appointmentStatus: formik.values.appointmentStatus, userId: formik.values.userId, startDate: startDateState, endDate: endDateState });
      dispatch(
        actions?.getAppointmentsRequest({
          ...payload,
          ...formik.values,
          startDate: startDateState,
          endDate: endDateState,
        })
      );
  }; 

  useEffect(() => {
    searchWithDate()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDateState, endDateState])

  return (
    <div className="apps-statistics-view">
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="row" style={{ flexWrap: 'nowrap' }}>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="userId"
              list={specialistList}
              keyName="name"
              valueKeyName="id"
              value={formik.values.userId}
              handleChange={(e) => searchWithUser(e, "userId")}
              error={formik.errors.userId}
            />
          </div>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="appointmentStatus"
              list={appStatus}
              keyName="name"
              valueKeyName="id"
              value={formik.values.appointmentStatus}
              handleChange={(e) => searchWithSelect(e, "appointmentStatus")}
              error={formik.errors.appointmentStatus}
            />
          </div>
          <div className="col-md-6 selection">
              <div className='dates-container'>
                  <div>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                              clearable
                              inputProps={{ 'placeholder': `${messages.shared.from}` }}
                              value={startDateState}
                              onChange={date => date ? setStartDateState(moment(date).format('YYYY-MM-DD')) : setStartDateState(null)}
                              format="yyyy-MM-dd"
                              keyboardIcon={<img src={calendar} alt="calendar" width="15px" height="15px"/>}
                          />
                      </MuiPickersUtilsProvider>
                  </div>
                  <div>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                              clearable
                              inputProps={{ 'placeholder': `${messages.shared.to}` }}
                              value={endDateState}
                              onChange={date => date ? setEndDateState(moment(date).format('YYYY-MM-DD')) : setEndDateState(null)}
                              format="yyyy-MM-dd"
                              keyboardIcon={<img src={calendar} alt="calendar" width="15px" height="15px"/>}
                          />
                      </MuiPickersUtilsProvider>
                  </div>
                  <div className='icon-container'>
                      <Tooltip title={`${messages.appointments.refresh}`} placement="bottom" >
                          <div><RefreshIcon title='clear' onClick={() => {
                              setStartDateState(null);
                              setEndDateState(null);
                              formik.setFieldValue('userId', 0);
                              formik.setFieldValue('appointmentStatus', 0);
                          }} /></div>
                      </Tooltip>
                  </div>
              </div>
            </div>
        </div>
      </form>
    </div>
  );
};

export default injectIntl(Filterform);
